import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define the API service
export const ormcustomerApi = createApi({
  reducerPath: 'ormcustomerApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Customer'], // Define the tag type for cache management and invalidation
  endpoints: (builder) => ({
    // Define the endpoints for your API
    findAllCustomers: builder.query({
      query: (company) => `ormcustomer/${company}`, // GET all customers by company
      providesTags: ['Customer'] // Cache with the 'Customer' tag
    }),
    findCustomerById: builder.query({
      query: (id) => `ormcustomer/byid/${id}`, // GET customer by ID
      providesTags: ['Customer'] // Cache with the 'Customer' tag
    }),
    insertCustomer: builder.mutation({
      query: (customer) => ({
        url: 'ormcustomer', // POST a new customer
        method: 'POST',
        body: customer
      }),
      invalidatesTags: ['Customer'] // Invalidate the 'Customer' tag cache
    }),
    updateCustomer: builder.mutation({
      query: (customer) => ({
        url: 'ormcustomer', // PUT update customer details
        method: 'PUT',
        body: customer
      }),
      invalidatesTags: ['Customer'] // Invalidate the 'Customer' tag cache
    }),
    deleteCustomer: builder.mutation({
      query: (id) => ({
        url: `ormcustomer/${id}`, // DELETE a customer by ID
        method: 'DELETE'
      }),
      invalidatesTags: ['Customer'] // Invalidate the 'Customer' tag cache
    })
  })
});

// Export the auto-generated hooks for the endpoints
export const {
  useFindAllCustomersQuery,
  useFindCustomerByIdQuery,
  useInsertCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation
} = ormcustomerApi;
